import { render, staticRenderFns } from "./MemberCoinsReport.vue?vue&type=template&id=4b017021&"
import script from "./MemberCoinsReport.vue?vue&type=script&lang=js&"
export * from "./MemberCoinsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports